import React, { Component } from 'react';
import { RootState } from '../../redux/store';
import { GraphState } from '../../redux/reducers/GraphReducer';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';

class GraphFooter extends Component<Props> {
  render() {
    const {
      graph: { response, selectedFields },
    } = this.props;
    return (
      response && (
        <div
          style={{ boxShadow: '0px -2px 12px 0px #0000000A' }}
          className={
            'flex w-full gap-x-2 box-border border-t rounded-xl border-b-none rounded-t-none border-[##E0E4E8] bg-main-gray items-center justify-center px-5  overflow-x-scroll '
          }
        >
          {selectedFields.map((item, index) => {
            return (
              <div key={index} className={'inline-flex items-center gap-x-2 px-5 py-2 shrink-0'}>
                <div className={'w-6 h-6 rounded-full'} style={{ backgroundColor: item.icon }}></div>
                <span className={'text-f-black-2 text-lg'}>{item.label}</span>
              </div>
            );
          })}
        </div>
      )
    );
  }
}

interface Props extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  pageFilter: state.page.filter,
  graph: state.graph as GraphState,
});
const mapDispatchToProps = {};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(GraphFooter);
